module.exports = __webpack_public_path__ + "static/1st-tpm-3-7ccd5ccc88d663328d804296c1e5b489.jpg";